<template>
  <div class="tab-group">
    <div class="filter-group">
      <div class="display-flex justify-content-between">
        <div class="wrap-left display-flex">
          <div class="item item__key input-custom-icon">
            <input v-model="keyword" v-debounce="300" type="text" placeholder="Tìm kiếm học sinh theo tên"
              class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width input-search" />
            <i class="icon-search font-size-16 primary-color"></i>
          </div>
        </div>
        <div class="wrap-right display-flex">
          <a @click="handleAddGroup" href="javascript:;"
            class="item btn btn-main btn-group border-rd-20 font-size-16 display-flex-center item__add">
            Tạo nhóm
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <TableGroup ref="TableGroup" @handleEditClassSchoolGroup="handleEditClassSchoolGroup"
          @handleShowListMember="handleShowListMember" @handleShowListDocument="handleShowListDocument"
          @getListDataAllGroup="getListDataAllGroup" />
      </div>
      <div class="col-md-6">
        <TableMemberGroup ref="TableMemberGroup" :classSchoolGroupId="classSchoolGroupIdView"
          v-if="typeShowTabRight == 1" />
        <ListDocument ref="ListDocument" :classSchoolGroupId="classSchoolGroupIdView" v-if="typeShowTabRight == 2" />
      </div>
    </div>

    <ModalCreateUpdateGroupClassSchool v-if="isModalCreateUpdateGroupClassSchool" :classSchoolId="classSchoolId"
      :classSchoolGroupId="classSchoolGroupId" @closeModal="closeModal" @handleDone="handleDone"
      :listDataAllGroup="listDataAllGroup" />
  </div>
</template>
<script>
import ModalCreateUpdateGroupClassSchool from "./../../_components/ModalCreateUpdateGroupClassSchool";

import TableMemberGroup from "./TableMemberGroup.vue";
import ListDocument from "./ListDocument.vue";
import TableGroup from "./TableGroup.vue";
import debounce from "@/directives/debounce";
export default {
  directives: { debounce },
  components: {
    ModalCreateUpdateGroupClassSchool,
    TableGroup,
    TableMemberGroup,
    ListDocument,
  },
  data() {
    return {
      typeShowTabRight: 0,
      classSchoolId: 0,
      keyword: "",
      isModalCreateUpdateGroupClassSchool: false,
      classSchoolGroupId: 0,
      classSchoolGroupIdView: 0,
      listDataAllGroup: [],
    };
  },
  watch: {
    keyword() {
      this.getAllGroupClassSchool();
    },
  },
  mounted() {
    this.classSchoolId = this.$route.query.id;
    this.getAllGroupClassSchool()
  },
  methods: {
    getListDataAllGroup(listGroup) {
      this.listDataAllGroup = listGroup
    },
    handleShowListDocument(classSchoolGroupId) {
      this.typeShowTabRight = 2;
      this.classSchoolGroupIdView = classSchoolGroupId;
      //this.$refs.ListDocument.getListLessonClassSchoolGroup(classSchoolGroupId)
    },
    handleShowListMember(classSchoolGroupId) {
      this.typeShowTabRight = 1;
      this.classSchoolGroupIdView = classSchoolGroupId;
      //this.$refs.TableMemberGroup.getListMemberByGroupId(classSchoolGroupId)
    },
    handleEditClassSchoolGroup(id) {
      this.classSchoolGroupId = id;
      this.isModalCreateUpdateGroupClassSchool = true;
    },
    handleDone() {
      this.getAllGroupClassSchool();
    },
    getAllGroupClassSchool() {
      this.typeShowTabRight = 0;
      this.$refs.TableGroup.getAllGroupClassSchool({ keyword: this.keyword });
    },
    handleAddGroup() {
      this.classSchoolGroupId = 0;
      this.isModalCreateUpdateGroupClassSchool = true;
    },
    closeModal() {
      this.isModalCreateUpdateGroupClassSchool = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.tab-group {
  margin-top: 20px;

  .filter-group {
    margin-bottom: 20px;
  }
}

.item__show_group {
  margin-right: 10px;
}

.btn-edit {
  color: #8ba3f9;
  cursor: pointer;
}

.btn-delete {
  color: red;
  cursor: pointer;
}

.col-table {
  font-size: 14px;
}

.text-btn-add-group {
  font-size: 12px;
  color: #4eec43;
}

.justify-content-between {
  justify-content: space-between;
}

.filter-group {
  margin: 10px 0px 10px 0px;
}

.col-md-6 {
  position: relative;
  height: 30rem;
}

.input-search {
  min-width: 18rem;
}
</style>